import Link from 'next/link';
import { useTranslations } from 'next-intl';

export function DontHaveAnAccountYet() {
  const t = useTranslations('auth');

  return (
    <div>
      <span className="text-sm leading-none font-normal text-neutral-200 dark:text-neutral-100">
        {t('common.noAccount')}{' '}
      </span>
      <span className="text-sm leading-none font-bold text-neutral-200 dark:text-neutral-100">
        <Link href={`${process.env.NEXT_PUBLIC_FE_URL_EOR}/sign-up`}>{t('common.signUp')}</Link>
      </span>
    </div>
  );
}
